import React, { FC } from 'react';
import { SpinnerIcon } from '../../../assets/icons';

interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  variant?: string;
  color?: string;
  fullWidth?: boolean;
  loading?: boolean;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const Button: FC<ButtonProps> = ({
  onClick,
  children,
  variant,
  className,
  loading,
  disabled,
  fullWidth,
  color,
}) => {
  const secondaryBtnColor: string =
    color === 'danger'
      ? 'text-danger border-danger/80 hover:border-danger/70  hover:ring-danger/60'
      : color === 'success'
      ? 'text-success border-success/80 hover:border-success/70 hover:ring-success/60'
      : 'text-primary border-primary/80 hover:border-primary/70 hover:ring-primary/60';

  const primaryBtnColor: string =
    color === 'danger'
      ? 'text-white bg-danger hover:bg-danger/70 focus:ring-danger/60'
      : color === 'success'
      ? 'text-white bg-success hover:bg-success/70 focus:ring-success/60'
      : 'text-white bg-primary hover:bg-primary/70 focus:ring-primary/60';

  const btnClass: string =
    variant === 'secondary'
      ? `w-full px-4 py-[10px] text-sm font-medium tracking-wide capitalize transition-colors duration-300 transform border  rounded-lg hover:outline-none hover:ring-1 hover:ring-opacity-50 focus:outline-none ${secondaryBtnColor}`
      : `w-full px-4 py-[10px] text-sm font-medium tracking-wide capitalize transition-colors duration-300 transform rounded-lg focus:outline-none focus:ring-1 focus:ring-opacity-50 ${primaryBtnColor}`;

  return (
    <div className={`flex flex-col ${fullWidth ? 'w-full' : 'w-24'}`}>
      <button
        className={`${btnClass} ${className} ${
          disabled || loading ? 'opacity-80 cursor-not-allowed' : ''
        }`}
        disabled={loading || disabled}
        onClick={onClick}
      >
        {loading ? <SpinnerIcon /> : children}
      </button>
    </div>
  );
};

export default Button;
